import React, { useState } from "react"
import { Link } from "gatsby"
import { Container, Row, Col, Form } from "react-bootstrap"
import { useStaticQuery, graphql } from "gatsby";
import ScrollAnimation from 'react-animate-on-scroll';
import parse from 'html-react-parser';
import GenerateLink from "../../common/site/generate-link"
import Map from "./map"
import "./OurNetwork.scss"
import { inViewOptions, containerVariants, contentItem, fadeInFromTop, titleVariants, contentVariants } from '../../utils/animation';

import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
const OurNetwork = (props) => { 
 

  return (
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.section
          className="our-network"
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}

        >
          <Container>
            <Row>
              <Col md="12" lg="6" xl="5">
                  <div className="about-content">
                    <span className="sub-title">{props.Title}</span>
                    <motion.div variants={contentVariants}>
                      {parse(props.Content)}
                    </motion.div>
                    {props.CTA_Label &&
                      <GenerateLink link={props.CTA_Link} class="btn"><span>{props.CTA_Label}</span> <i class="icon-arrow"></i></GenerateLink>
                    }
                  </div>
              </Col>
              <Col md="12" lg="6" xl="7"  className="mt-4 agent-network order-md-first order-first order-lg-last">
                  <motion.div variants={contentVariants} className="animation-map">
                    <Map />
                    {/* {network.Our_Network_Image &&
                      <picture className="about-block-img">
                        <img src={network.Our_Network_Image.url} alt={network.Our_Network_Image.alternativeText} />
                      </picture>
                    } */}
                  </motion.div>
              </Col>
            </Row>
          </Container>
        </motion.section>
      )}
    </InView>
  )
}
export default OurNetwork
